 import Alert from 'react-s-alert';
// mandatory
import 'react-s-alert/dist/s-alert-default.css'; 
// optional - you can choose the effect you want
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import 'react-s-alert/dist/s-alert-css-effects/scale.css';
import 'react-s-alert/dist/s-alert-css-effects/bouncyflip.css';
import 'react-s-alert/dist/s-alert-css-effects/flip.css';
import 'react-s-alert/dist/s-alert-css-effects/genie.css';
import 'react-s-alert/dist/s-alert-css-effects/jelly.css';
import 'react-s-alert/dist/s-alert-css-effects/stackslide.css'; 

export const AlertPopup=(type,text)=>{ 
    console.log(type,text);
    switch (type) {
        case 'Warning': Alert.warning(text,{position: 'bottom-right',effect: 'scale',onShow: function () {console.log('aye!')},beep: false,timeout: 3000,offset: 100});break;
        case 'Info': Alert.info(text, {position: 'bottom-right',effect: 'scale',onShow: function () {},beep: false,timeout: 4000,offset: 0});break;
        case 'Error': Alert.error(text, {position: 'bottom-right',effect: 'scale',onShow: function () {},beep: false,timeout: 4000,offset: 0});break;
        case 'Success': Alert.success(text, {position: 'bottom-right',effect: 'scale',onShow: function () {},beep: false,timeout: 4000,offset: 0});break;
        default: Alert.closeAll(); break;
    }
}

// export default class Index extends React.Component {}

export const ReDate=(TimeStamp)=>{
    var myDate = new Date(TimeStamp);
    var date = (myDate.getDate()<10?'0':'')+(myDate.getDate());
    var month = (myDate.getMonth()+1<10?'0':'')+(myDate.getMonth()+1);
    var year = myDate.getFullYear() +543;
    return date+"/"+month+"/"+year;
}

/*_______________________________________________วิธีใช้_______________________________________________*/

// 1.  import {AlertPopup} from './AlertPopup';
// 2.  AlertPopup('______(1)______','______(2)_______')
//          (1) สถานะ Warning,Info,Error,Success
//          (2) ข้อความที่จะแสดง
//
// __ตัวอย่าง.__ AlertPopup('Success',"บันทึกสำเร็จ")
